import request from "@/utils/http.js";

export function queryStudentAut(options) {
  return request({
    url: "/schoolManager/queryStudentAuth",
    method: "post",
    data: options,
  });
}

//token获取用户信息
export const getUserInfo = async (options) => {
  return request({
      url: '/businessPro/getUserInfo',
      method: 'post',
      data: options
  })
  return {
    data: {
      status: 0,
      msg: "获取成功!",
      result: {
        userId: 2085546,
        groupId: null,
        loginName: "us00610563",
        userName: "王小刚2",
        nickname: "王小刚2",
        password: "",
        oldPassword: "",
        salt: "e10adc3949ba59abbe56e057f20f883e",
        userType: 1,
        isAdmin: 0,
        identityCard: null,
        sex: null,
        phone: null,
        email: null,
        identityCardAuth: 0,
        phoneAuth: 0,
        emailAuth: 0,
        birthday: null,
        countryId: 999999,
        provinceId: 9,
        cityId: 109,
        areaId: 1319,
        address: null,
        insertDate: "2025-01-03T07:28:31.000+0000",
        insertBy: 2085497,
        updateDate: null,
        updateBy: null,
        status: 0,
        isDelete: 0,
        origin: "校园管理平台",
        pic: "user/defaultPic.jpg",
        base64: null,
        userProfile: null,
        teacher: null,
        student: null,
        functions: null,
        partyId: null,
        userRoles: null,
        introduction: null,
        profile: null,
        code: null,
        className: null,
        schoolName: "上海市嘉定区清水路小学",
        teacherNumber: null,
        site: {
          pageSize: null,
          currentPage: null,
          startIndex: null,
          siteId: 4000001,
          siteName: null,
          siteNumber: null,
          siteSubdomain: null,
          siteUrl: null,
          siteAbout: null,
          siteCode: null,
          siteLogo: null,
          relationLogo: null,
          insertBy: null,
          insertDate: null,
          updateDate: null,
          updateBy: null,
          isDelete: null,
          siteTag: null,
          schoolId: null,
          areaId: null,
        },
        classId: null,
        schoolId: null,
        gradeId: null,
        tag: null,
        isClient: 0,
        openId: null,
        phaseId: null,
        isActivate: 1,
        prefix: null,
        authArea: 0,
        userCountryId: 999999,
        userProvinceId: 9,
        userCityId: 109,
        userAreaId: 1319,
        userSchoolName: null,
        schoolVOList: null,
        authType: null,
        authSchoolId: null,
        courseSchoolVO: null,
        schoolList: null,
        registerCertificate: null,
        difference: null,
        unionid: null,
        geniusShowOpenId: null,
        matchPortal: null,
        logAction: null,
        source: "register",
      },
    },
  };
};
